<template>
  <div :class="{ 'has-error' : localErrors.has(name) }" class="input-wrap">
    <v-md-date-range-picker :start-date="pickerDateStart"
                            :end-date="pickerDateEnd"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :notAllowOneDay="notAllowOneDay"
                            :singleDatePicker="singleDatePicker"
                            :showPresets="showPresets"
                            :opens="opens || 'center'"
                            :auto-apply="autoApply"
                            :aria-disabled="true"
                            :presets="rangesLocalized"
                            :events="events"
                            @change="dateChange($event)"
                            @nextMonthClicked="$emit('nextMonthClicked' , $event)"
                            @prevMonthClicked="$emit('prevMonthClicked' , $event)"
                            ref="VMdDateRangePicker"
                            class="with-icon-calendar ml-auto">

      <template slot="input">


        <CustomActivator :value="value_"
                         :errorsBag="errorsBag"
                         @click="onActivate"
                         ref="defaultActivator"
                         name="dateEnd"
                         readonly/>
      </template>
    </v-md-date-range-picker>
    <div v-show="localErrors.has(name)" class="help-text">{{ localErrors.first(name) }}</div>
  </div>
</template>

<script>
import CustomActivator from '@/components/DatePicker/CustomActivator.vue';
import { getFutureRanges, getRanges, getNetTermsRanges } from '@/lib/periodToDates';
import moment from 'moment';

import VMdDateRangePicker from '@/components/DatePicker/VMdDateRangePicker2/src/components/Picker.vue';
// import Vue from "vue";
// import VMdDateRangePicker from "v-md-date-range-picker";
// Vue.use(VMdDateRangePicker);

export default {
  name: 'DateSelect',

  components: {
    CustomActivator,
    VMdDateRangePicker
  },

  props: ['dateStart', 'dateEnd', 'name', 'value', 'placeholder', 'errorsBag', 'opens', 'autoApply', 'minDate', 'maxDate', 'futurePresets', 'netTermsPresets', 'showPresets', 'notAllowOneDay', 'singleDatePicker', 'events', 'emptySelection'],

  data: function () {
    return {
      localErrors: this.errorsBag,
      ranges: [],
      currentDate: moment().format('YYYY-MM-DD'),
      emptySelectionDate: '1900-01-01',

    };
  },

  computed: {
    rangesLocalized () {
      return this.ranges.map(range => ({
        label: this.$t(range.label),
        name: range.label,
        range: range.range,

      }));
    },

    value_ () {
      if (this.singleDatePicker) {
        return this.dateStart;
      }
      if (this.value) {
        return this.$t(this.value);
      }
      return this.placeholder ? this.$t(this.placeholder) : '';
    },

    hasSelectedDates () {
      return !!(this.dateStart && this.dateEnd);
    },

    pickerDateStart () {
      return this.emptySelection ? this.dateStart || this.currentDate : this.dateStart;
    },

    pickerDateEnd () {
      return this.emptySelection ? this.dateEnd || this.currentDate : this.dateEnd;
    }
  },

  created: function () {
    this.localErrors = this.errorsBag || this.errors;
    if (this.netTermsPresets === true) {
      this.ranges = getNetTermsRanges();
    } else if (this.futurePresets === true) {
      this.ranges = getFutureRanges();
    } else {
      this.ranges = getRanges();
    }

  },
  watch: {
    dateStart () {
      this.syncPickerEmptyState();
    },

    dateEnd () {
      this.syncPickerEmptyState();
    },
  },
  mounted () {
    this.$refs.VMdDateRangePicker.locale.applyLabel = this.$t(this.$refs.VMdDateRangePicker.locale.applyLabel);
    this.$refs.VMdDateRangePicker.locale.cancelLabel = this.$t(this.$refs.VMdDateRangePicker.locale.cancelLabel);
    this.$refs.VMdDateRangePicker.locale.customRangeLabel = this.$t(this.$refs.VMdDateRangePicker.locale.customRangeLabel);
    this.$refs.VMdDateRangePicker.locale.daysOfWeek = this.$refs.VMdDateRangePicker.locale.daysOfWeek.map(dayOfWeek => this.$t('DAY_OF_WEEK_SHORT_' + dayOfWeek));
    this.$refs.VMdDateRangePicker.locale.monthNames = this.$refs.VMdDateRangePicker.locale.monthNames.map(monthName => this.$t('MONTH_NAME_SHORT_' + monthName));

    document.querySelector('.mdrp__activator').addEventListener('click', () => {
      this.onActivate();
    });

    this.syncPickerEmptyState();
  },

  methods: {
    onActivate () {
      this.$emit('open');

      if (this.currentDate !== moment().format('YYYY-MM-DD')) {
        this.currentDate = moment().format('YYYY-MM-DD');
        this.ranges = getRanges();
      }

      this.$nextTick(() => {
        this.syncPickerEmptyState();
      });
    },
    dateChange (dateRange) {
      if (!dateRange[0].isValid() || !dateRange[1].isValid() || (this.emptySelection && this.isEmptySelectionRange(dateRange))) {
        return;
      }

      this.$emit('change', {
        dateStart: dateRange[0].format('YYYY-MM-DD'),
        dateEnd: dateRange[1].format('YYYY-MM-DD'),
      });
    },

    syncPickerEmptyState () {
      if (!this.emptySelection || this.hasSelectedDates || !this.$refs.VMdDateRangePicker) {
        return;
      }

      const picker = this.$refs.VMdDateRangePicker;
      const emptyDate = moment(this.emptySelectionDate);

      picker.start_ = emptyDate.clone();
      picker.end_ = emptyDate.clone();
      picker.hoverStart_ = emptyDate.clone();
      picker.hoverEnd_ = emptyDate.clone();
      picker.cloneStart = emptyDate.clone();
      picker.cloneEnd = emptyDate.clone();

      this.$nextTick(() => {
        picker.leftCalendarMonth_ = moment(this.pickerDateStart);
        picker.rightCalendarMonth_ = moment(this.pickerDateEnd);
      });
    },

    isEmptySelectionRange (dateRange) {
      return dateRange[0].format('YYYY-MM-DD') === this.emptySelectionDate &&
        dateRange[1].format('YYYY-MM-DD') === this.emptySelectionDate;
    }
  },
};
</script>
